import { useState } from "react";
import { Wrench } from "lucide-react";
import { useAuth } from "@/auth/useAuth";
import type { UserRole } from "@/types";

const DEV_PANEL_ENABLED = import.meta.env.VITE_SHOW_DEV_PANEL === "true";

export function DevLoginPanel() {
  const { user, devLogin, logout, requestMagicLink } = useAuth();
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(true);

  if (!DEV_PANEL_ENABLED) return null;
  if (!devLogin) return null;

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-4 right-4 bg-yellow-500 text-black w-10 h-10 rounded-full shadow-lg z-50 hover:bg-yellow-400 transition-colors"
        title="Apri pannello dev"
      >
        <Wrench size={18} className="mx-auto" />
      </button>
    );
  }

  async function fakeLogin(role: UserRole) {
    try {
      await devLogin!(role);
    } catch (e) {
      console.error("dev-login failed", e);
      alert("Dev login fallito — controlla i log del backend.");
    }
  }

  async function realMagicLink() {
    if (!email) return;
    try {
      await requestMagicLink(email);
      alert(
        `Magic link richiesto per ${email}. In dev (EMAIL_BACKEND=console) il link è nei log del backend: ssh vmaenergia 'sudo journalctl -u portale-backend | grep CONSOLE'`
      );
    } catch (e) {
      console.error("magic link failed", e);
      alert("Richiesta fallita — controlla i log.");
    }
  }

  return (
    <div className="fixed bottom-4 right-4 bg-gray-900 text-white p-4 rounded-lg shadow-2xl border-2 border-yellow-500 w-72 z-50 text-sm">
      <div className="flex justify-between items-center mb-3">
        <strong className="text-yellow-400 flex items-center gap-1.5"><Wrench size={14} /> DEV PANEL</strong>
        <button
          onClick={() => setOpen(false)}
          className="text-gray-400 hover:text-white text-lg leading-none"
        >
          ×
        </button>
      </div>
      {user ? (
        <div className="space-y-2">
          <div className="text-xs text-gray-300">
            Loggato: <strong>{user.email}</strong>
            <br />
            Ruoli: {user.roles.join(", ")}
          </div>
          <button
            onClick={() => logout()}
            className="w-full bg-red-600 hover:bg-red-700 py-1.5 rounded text-xs font-medium"
          >
            Logout
          </button>
        </div>
      ) : (
        <div className="space-y-3">
          <div>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tua@email.it"
              className="w-full px-2 py-1.5 bg-gray-800 rounded text-white text-xs outline-none border border-gray-700"
            />
            <button
              onClick={realMagicLink}
              className="mt-1.5 w-full bg-green-600 hover:bg-green-700 py-1.5 rounded text-xs font-medium"
            >
              Magic link reale (console)
            </button>
          </div>
          <hr className="border-gray-700" />
          <div className="space-y-1">
            <button
              onClick={() => fakeLogin("cliente")}
              className="w-full bg-blue-600 hover:bg-blue-700 py-1.5 rounded text-xs font-medium"
            >
              Login fake CLIENTE
            </button>
            <button
              onClick={() => fakeLogin("affiliato")}
              className="w-full bg-blue-600 hover:bg-blue-700 py-1.5 rounded text-xs font-medium"
            >
              Login fake AFFILIATO
            </button>
            <button
              onClick={() => fakeLogin("operatore")}
              className="w-full bg-blue-600 hover:bg-blue-700 py-1.5 rounded text-xs font-medium"
            >
              Login fake OPERATORE
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
